<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		version="1.1"
		viewBox="0.00 0.00 54.00 68.00"
		class="logo-animation"
	>
		<path
			fill="none"
			stroke-width="1.00"
			stroke="#ffb400"
			vector-effect="non-scaling-stroke"
			d="
                M 23.20 18.34
                Q 23.44 19.39 24.07 18.52
                C 29.24 11.43 40.05 -1.03 49.30 0.56
                Q 49.93 0.67 49.61 1.22
                C 44.33 10.09 41.40 22.13 48.50 30.93
                C 54.16 37.95 55.11 47.61 50.57 55.12
                Q 46.27 62.25 39.13 64.85
                C 25.82 69.69 5.31 68.56 1.76 51.20
                Q -0.71 39.15 4.21 28.71
                C 8.39 19.83 14.67 10.74 23.91 6.87
                Q 24.72 6.53 24.45 7.36
                C 23.33 10.74 22.39 14.83 23.20 18.34
                Z
                M 24.53 36.98
                Q 18.85 33.31 19.21 27.59
                Q 19.25 26.92 18.62 27.16
                C 11.05 30.05 7.66 39.34 8.37 46.74
                Q 9.60 59.50 22.15 61.36
                C 29.92 62.51 37.56 60.47 41.71 53.49
                C 49.13 40.99 36.68 33.19 33.78 22.23
                Q 33.59 21.50 32.95 21.90
                C 28.17 24.84 26.11 31.04 25.25 36.65
                Q 25.14 37.38 24.53 36.98
                Z"
		/>
	</svg>
</template>

<style>
.logo-animation {
    opacity: 1;
    stroke-dasharray: 350, 200;
    stroke-dashoffset: 0;
    animation: svg-fill 2s infinite both;
}

@keyframes svg-fill {
    50% {
        stroke-dasharray: 0.001, 200;
        stroke-dashoffset: -100;
    }

    0%,
    100% {
        stroke-dasharray: 400, 200;
        stroke-dashoffset: 0;
    }
}
</style>
